import React, { memo } from 'react';
import { Formatter } from '@core/utils/formatter';
import { TableColumn } from '@modules/common/TableColumn';
import { useCompany } from '@core/utils/hooks/misc';

export interface FeeLineItemProps {
  editable?: boolean;
  title: string;
  serviceName: string;
  percent: number;
  total: number;
}

export const FeeLineItem = memo((props: FeeLineItemProps) => {
  const { total, title, serviceName, percent, editable } = props;
  const company = useCompany();

  return (
    <div className="d-flex align-items-center" style={{ padding: '10px 0px' }}>
      <TableColumn width={50} maxWidth={50}></TableColumn>
      <TableColumn>{title}</TableColumn>
      {!!editable && <TableColumn maxWidth={100}>{percent}</TableColumn>}
      <TableColumn maxWidth={200}>{Formatter.formatCurrency(total, company.currencyCode)}</TableColumn>
    </div>
  );
});
